export default __webpack_public_path__ + "static/media/mobileview.1ed8614a.png";